import { useEffect, useState } from "react";
import { Link } from "react-router-dom";
import { api } from "@/lib/api";
import { Card, CardContent } from "@/components/ui/card";
import { Input } from "@/components/ui/input";
import { Badge } from "@/components/ui/badge";
import { Star, Search } from "lucide-react";

export default function Directory() {
  const [pros, setPros] = useState([]);
  const [q, setQ] = useState("");
  const [filter, setFilter] = useState("Todos");

  useEffect(() => { api.get("/professionals").then((r) => setPros(r.data)); }, []);

  const allExpertise = Array.from(new Set(pros.flatMap((p) => p.expertise || [])));
  const filtered = pros.filter((p) => {
    const matchesQ = !q || p.name.toLowerCase().includes(q.toLowerCase()) || (p.specialty || "").toLowerCase().includes(q.toLowerCase());
    const matchesF = filter === "Todos" || (p.expertise || []).includes(filter);
    return matchesQ && matchesF;
  });

  return (
    <div className="container-optia py-12 animate-fade-in">
      <div className="max-w-3xl">
        <h1 className="font-display text-3xl md:text-4xl font-semibold text-navy-900">Encontre seu profissional</h1>
        <p className="mt-2 text-slate-600 text-lg">Todos com formação e prática em cuidado afirmativo.</p>
      </div>

      <div className="mt-8 flex flex-col md:flex-row md:items-center gap-3">
        <div className="relative flex-1 max-w-md">
          <Search className="absolute left-3 top-1/2 -translate-y-1/2 w-4 h-4 text-slate-400" />
          <Input placeholder="Buscar por nome ou especialidade" className="pl-9 h-11" value={q} onChange={(e)=>setQ(e.target.value)} data-testid="directory-search" />
        </div>
        <div className="flex gap-2 flex-wrap" data-testid="directory-filters">
          {["Todos", ...allExpertise].map((f) => (
            <button key={f} onClick={()=>setFilter(f)}
              className={`px-3 py-1.5 rounded-full text-sm border transition ${filter===f ? "bg-navy-900 border-navy-900 text-white" : "bg-white border-slate-300 text-slate-700 hover:border-navy-500"}`}
              data-testid={`directory-filter-${f}`}>{f}</button>
          ))}
        </div>
      </div>

      <div className="mt-8 grid gap-5 sm:grid-cols-2 lg:grid-cols-3">
        {filtered.map((p) => (
          <Link to={`/profissionais/${p.id}`} key={p.id} className="group" data-testid={`prof-card-${p.id}`}>
            <Card className="card-soft group-hover:border-teal-400 transition h-full">
              <CardContent className="p-6">
                <div className="flex gap-4 items-start">
                  {p.avatar ? (
                    <img src={p.avatar} alt={p.name} className="h-16 w-16 rounded-2xl object-cover" />
                  ) : (
                    <div className="h-16 w-16 rounded-2xl bg-teal-100 grid place-items-center text-teal-700 font-bold text-2xl">{p.name?.charAt(0)}</div>
                  )}
                  <div className="flex-1 min-w-0">
                    <h3 className="font-display font-semibold text-navy-900 truncate">{p.name}</h3>
                    <p className="text-sm text-teal-700">{p.specialty}</p>
                    <div className="flex items-center gap-1 mt-1 text-sm text-slate-600">
                      <Star className="w-3.5 h-3.5 fill-amber-400 text-amber-400" />
                      <span className="font-medium">{p.rating || "—"}</span>
                      <span className="text-slate-400">·</span>
                      <span>R$ {p.price_per_session}/consulta</span>
                    </div>
                  </div>
                </div>
                <p className="text-sm text-slate-600 mt-4 line-clamp-2">{p.bio}</p>
                <div className="flex flex-wrap gap-1.5 mt-3">
                  {(p.expertise || []).slice(0, 3).map((e) => (
                    <Badge key={e} className="bg-teal-50 text-teal-800 hover:bg-teal-50 border-0 text-xs">{e}</Badge>
                  ))}
                </div>
              </CardContent>
            </Card>
          </Link>
        ))}
      </div>
      {filtered.length === 0 && <p className="text-slate-500 mt-10 text-center">Nenhum profissional encontrado.</p>}
    </div>
  );
}
